import { AppCheckbox } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { INQUIRY_START_ASAP_LABELS } from 'shared'

/**
 * 引合の開始日「なる早」チェックボックスの props
 * - checked: なる早かどうか
 * - onCheckedChange: チェック切替時のコールバック（boolean に正規化済み）
 * - disabled: 確定済みなど編集不可のとき true
 */
export interface AppStartAsapCheckboxProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
}

/**
 * 引合の開始日「なる早（開始日未定・できるだけ早く）」チェックボックス。
 * 登録ダイアログと詳細の基本情報タブで同じ見た目・同じ文言にするための共通部品。
 *
 * ラベルはアプリ内の他のチェックボックス（14px）より小さい 12px にしている。
 * 補足説明まで含めた長いラベルで、隣の開始日入力欄と並べたときに 14px だと 2 行に折り返すため。
 * 文言は shared の INQUIRY_START_ASAP_LABELS.CHECKBOX_LABEL が正。
 */
export function AppStartAsapCheckbox({ checked, onCheckedChange, disabled }: AppStartAsapCheckboxProps) {
  return (
    <AppCheckbox
      label={INQUIRY_START_ASAP_LABELS.CHECKBOX_LABEL}
      checked={checked}
      onCheckedChange={(value) => onCheckedChange(value === true)}
      disabled={disabled}
      labelClassName='font-normal text-xs'
    />
  )
}
